import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DynamicComponentLoader } from '../dynamicComponentLoader.service';
// import { DynamicComponentLoader } from '../dynamicComponentLoader.service';

@Injectable({
    providedIn:"root"
})

export class RechargeBoxService {
    private _rechargeBoxSource = new BehaviorSubject<boolean>(false);
    private isLoaded = false;
    rechargeBox$ = this._rechargeBoxSource.asObservable();
    constructor(private _dcl:DynamicComponentLoader)
    {

    }
 
    async changeDisplayStatus(status) {

        if (!this.isLoaded) {
            this.isLoaded = true;
            const { RechargeBoxComponent } = await import("../../components/recharge-box/recharge-box.component");
            this._dcl.createComponent(RechargeBoxComponent);
          
        }
        this._rechargeBoxSource.next(status);
    }
}
